import api from './api';
import { errorHandler } from './errorHandler';

class EmailAddressSearchService {
  private searchController: AbortController | null = null;

  cancelPreviousSearch() {
    if (this.searchController) {
      this.searchController.abort();
      this.searchController = null;
    }
  }

  async searchAddresses(query: string, limit: number = 10): Promise<string[]> {
    try {
      // Cancel any ongoing request
      this.cancelPreviousSearch();

      // Create a new AbortController for this request
      this.searchController = new AbortController();

      const response = await api.get(`/api/email/search/addresses?q=${query}&limit=${limit}`, {
        signal: this.searchController.signal
      });

      // Clear the controller after successful request
      this.searchController = null;

      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        // Don't throw error if request was aborted
        if (error.name === 'AbortError') {
          return [];
        }
        // Check if it's a network error
        if (!window.navigator.onLine || error.message.includes('Network') || error.message.includes('Failed to fetch')) {
          errorHandler.showNetworkError();
        }
      }
      console.error('Error searching email addresses:', error);
      throw error;
    }
  }
}

export const emailAddressSearchService = new EmailAddressSearchService();
